export enum FormMode {
    CREATE = 'create',
    UPDATE = 'update',
    DUPLICATE = 'duplicate',
    DISPLAY = 'display'
}